<div>
  <!-- Title -->
  <h3>{{'penalties.management.header' | translate}}</h3>
  <hr>
  <app-penalty-table *ngIf="penaltyObservable | async as penalties" [penalties]="penalties" [showDesignee]="true" [showDelete]="true" [showTitle]="false" (onDelete)="onDelete()"></app-penalty-table>
</div>
